/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_NameInputs */

const vi_grower_name = /** @type {(inputs: Grower_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên hộ`)
};

/**

* @param {Grower_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_name = /** @type {((inputs?: Grower_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_name(inputs)
});